export class Industry {
  id: number = -1;
  name: string = '';
  createdAt: string = '';
  updatedAt: string = '';
}
